"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = _interopRequireDefault(require("./api.local"));
var _api2 = _interopRequireDefault(require("./api.dev"));
var _api3 = _interopRequireDefault(require("./api.qa"));
var _api4 = _interopRequireDefault(require("./api.prod"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Default to QA for now
var API = _api3.default;
var ENV_FLAG;
if (window && window.Liferay) {
  ENV_FLAG = window.Liferay.INSURED_ENV;
} else if (process && process.env) {
  ENV_FLAG = process.env.INSURED_ENV;
}
if (ENV_FLAG === 'prod') {
  API = _api4.default;
} else if (ENV_FLAG === 'dev') {
  API = _api2.default;
} else if (ENV_FLAG === 'local') {
  API = _api.default;
} else {}
var _default = exports.default = API;